import { render, staticRenderFns } from "./EndorsementList.vue?vue&type=template&id=21c79c18&scoped=true"
import script from "./EndorsementList.vue?vue&type=script&lang=ts"
export * from "./EndorsementList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c79c18",
  null
  
)

export default component.exports